import React, { FC } from 'react'
import { Autocomplete, TextField, Box, Chip } from '@mui/material'

type TagAutocompleteProps = {
  value: string[]
  options: string[]
  onChange: (newValue: string[]) => void
  maxWidth?: number
}

export const TagAutocomplete: FC<TagAutocompleteProps> = ({
  value,
  options,
  onChange,
  maxWidth = 400,
}) => (
  <Box mb={2}>
    <Autocomplete
      multiple
      value={value}
      onChange={(_event, newValue) => onChange(newValue)}
      options={options}
      renderInput={(params) => <TextField {...params} label="タグで絞り込む" />}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={option}
            label={`${option}`}
            color="info"
            size="small"
          />
        ))
      }
      getOptionLabel={(option) => `${option}`}
      noOptionsText="タグが見つかりません"
      clearText="クリア"
      openText="開く"
      closeText="閉じる"
      sx={{ maxWidth }}
    />
  </Box>
)
